<template>
  <div class="form">
  <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Form',
  props: [],
  data() {
    return {
      
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
}
</style>
